// Pre-compute date for offer so we don't re-run every function call
let formattedDate;
const getValidUntilDate = () => {
    if (formattedDate) return formattedDate;
    // Otherwise create in-mem store
    const date = new Date();
    date.setTime(date.getTime() + 864000000); // Avoid multiplication
    formattedDate = date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
    return formattedDate;
};

export const productSchema = (product, url) => {
    const ratingValueExtraction = product?.rating?.value ? JSON.parse(product.rating.value)?.value : null;

    const schema = {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        name: `${product?.vendor} ${product?.title}`,
        image: product?.featuredImage?.url,
        description: product?.title,
        sku: product?.variants?.nodes?.[0]?.sku,
        url: url,
        gtin: product?.variants?.nodes?.[0]?.barcode,
        brand: {
            '@type': 'Brand',
            name: product?.vendor
        },
        ...(ratingValueExtraction
            ? {
                  aggregateRating: {
                      '@type': 'AggregateRating',
                      itemReviewed: `${product?.vendor} ${product?.title}`,
                      bestRating: '5',
                      worstRating: '1',
                      ratingValue: ratingValueExtraction,
                      reviewCount: product?.ratingCount?.value
                  }
              }
            : {}),
        offers: {
            '@type': 'Offer',
            url: url,
            priceCurrency: product?.priceRange?.maxVariantPrice?.currencyCode || product?.priceRangeV2?.maxVariantPrice?.currencyCode,
            price: product?.priceRange?.maxVariantPrice?.amount || product?.priceRangeV2?.maxVariantPrice?.amount,
            priceValidUntil: getValidUntilDate(),
            itemCondition: 'http://schema.org/NewCondition',
            availability: `http://schema.org/${product?.availableForSale ? 'InStock' : 'OutOfStock'}`,
            seller: {
                '@type': 'Organization',
                name: 'Caktus Vape'
            }
        }
    };

    return schema;
};
